import {Box, Button, Menu, MenuProps, rem} from "@mantine/core";
import {IconDropletFilled} from "@tabler/icons-react";
import {TransportCategory, transportCategory} from "@ots-frontend/ots-data";
import {getTransportCategoryColorRefByType} from "../../../util/transport-category-ui-util";
import {useTranslation} from "react-i18next";
import {transportCategoryOilColor, transportCategoryWaterColor} from "../../../theme/colors";

export type TransportCategoryMenuProps = MenuProps & {
  category: TransportCategory
  onCategoryClick: (category: TransportCategory) => void
}

export const TransportCategoryMenu = (props: TransportCategoryMenuProps) => {
  const {category, onCategoryClick, ...rest} = props

  const {t} = useTranslation(["common"])

  return (
    <Menu {...rest}>
      <Menu.Target>
        <Box w={100}>
          <Button fullWidth color={getTransportCategoryColorRefByType(category)}>
            {t(category.displayValue.id, category.displayValue.defaultMessage)}
          </Button>
        </Box>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Category</Menu.Label>
        <Menu.Item
          icon={<IconDropletFilled style={{color: transportCategoryWaterColor, width: rem(14), height: rem(14)}}/>}
          onClick={() => onCategoryClick(transportCategory.water)}
        >
          {t(transportCategory.water.displayValue.id, transportCategory.water.displayValue.defaultMessage)}
        </Menu.Item>
        <Menu.Item
          icon={<IconDropletFilled style={{color: transportCategoryOilColor, width: rem(14), height: rem(14)}}/>}
          onClick={() => onCategoryClick(transportCategory.oil)}
        >
          {t(transportCategory.oil.displayValue.id, transportCategory.oil.displayValue.defaultMessage)}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}
